/** @file Loop pass of an animation-time position; one boundary rule for stepState and addAnimation. */

/** Passes of slack: a position within this of a pass boundary (float error) counts as having reached it (R4-01). */
const PASS_EPSILON = 1e-9;

/**
 * Completed passes of a loop `duration` (> 0) long at animation time `a`: floor(a / duration), where a position
 * within PASS_EPSILON passes below a boundary counts as past it. stepState (loop split and complete), addAnimation
 * (take-over) and applyState (wrapped sample time) all read this, so they agree on every boundary.
 */
export function loopPass(a: number, duration: number): number {
  return Math.floor(a / duration + PASS_EPSILON);
}
